let observer;
const callBackMap = /* @__PURE__ */ new WeakMap();
function init() {
  if (observer)
    return;
  observer = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const maybeCallBacks = callBackMap.get(entry.target);
      const safeCallBacks = maybeCallBacks != null ? maybeCallBacks : [];
      if (safeCallBacks.length === 0)
        return;
      requestAnimationFrame(() => {
        for (const callback of safeCallBacks) {
          if (typeof callback === "function") {
            callback(entry);
          } else {
            callback.current(entry);
          }
        }
      });
    }
  });
}
function assertIsResizeOberver(obj) {
  if (obj === void 0) {
    throw new Error("ResizeObserver is not defined.  Please call init()");
  }
}
function registerCallback(node, cb) {
  var _a;
  assertIsResizeOberver(observer);
  const callbacks = (_a = callBackMap.get(node)) != null ? _a : [];
  callBackMap.set(node, callbacks.concat(cb));
  observer.observe(node);
  return () => {
    assertIsResizeOberver(observer);
    const maybeCallBacks = callBackMap.get(node);
    const safeCallBacks = maybeCallBacks != null ? maybeCallBacks : [];
    const newCallbacks = safeCallBacks.filter((ref) => ref !== cb);
    callBackMap.set(node, newCallbacks);
    if (newCallbacks.length === 0) {
      observer.unobserve(node);
      callBackMap.delete(node);
    }
  };
}
export { init, registerCallback };
